import React, { useEffect, useState } from 'react';
import styles from './group-add-participants-page.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addClientGroupBd, getClientsDb, getGrupListDb } from '../../firebase';
import { addClientsRedux, pushParticipan } from '../../store/slices/clientsSlice';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import { addGroupRedux } from '../../store/slices/groupsSlice';
import { generateRandomString } from '../../helper';

export default function GroupAddParticipantsPage() {
  // console.log('render/GroupAddParticipantsPage');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { group_id } = useParams();

  const [loaderPage, setLoaderPage] = useState(false);
  const clients = useSelector((state) => state.clients.clients);
  const groupsList = useSelector((state) => state.groups.groupsList);

  // Пошук клієнтів
  const [searchСlientsArray, setSearchСlientsArray] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!clients.length) {
      setLoaderPage(true);
      const getClients = async () => {
        const clients = await getClientsDb();
        dispatch(addClientsRedux(clients));
        // console.log('clients ===', clients);
        setLoaderPage(false);
      };
      getClients();
    }
    if (!groupsList.length) {
      setLoaderPage(true);
      const getGroupList = async () => {
        const groupsList = await getGrupListDb();
        dispatch(addGroupRedux(groupsList));
        setLoaderPage(false);
      };
      getGroupList();
    }
  }, []);

  // Отримує всіх клієнтів які ще не беруть участі в цій групі
  const getClientsNotParticipationGroup = (clients) => {
    // console.log('render/getClientsNotParticipationGroup');
    const clientsNotParticipationGroup = [];

    clients.forEach((item) => {
      if (Object.keys(item.participationGroups).length == 0) {
        clientsNotParticipationGroup.push(item);
      } else {
        const participationGroupsKeys = Object.keys(item.participationGroups);

        let isParticipationGroup = false;

        participationGroupsKeys.forEach((participationGroupKey) => {
          if (group_id === item.participationGroups[participationGroupKey].group_id) {
            isParticipationGroup = true;
          }
        });

        if (!isParticipationGroup) {
          clientsNotParticipationGroup.push(item);
        }
      }
    });
    return clientsNotParticipationGroup;
  };

  // Додає клієнта в групу
  const addClientGroup = (client, group_id) => {
    // console.log(client);
    // console.log(group_id);

    setLoaderPage(true);
    const groupObject = groupsList.filter((item) => {
      return item.group_id === group_id;
    })[0];

    let groupObject_link = `group_${generateRandomString()}`;

    const participan_object = { ...groupObject, accessGroup: false };

    const addClientGroup = async () => {
      const isAddClientGroupBd = await addClientGroupBd(
        client.client_id,
        participan_object,
        groupObject_link,
      );

      if (isAddClientGroupBd) {
        dispatch(
          pushParticipan({ client_id: client.client_id, participan_object, groupObject_link }),
        );
      }
      setLoaderPage(false);
    };

    addClientGroup();
    setSearch('');
    setSearchСlientsArray([]);
  };

  const renderClients = (clients) => {
    return clients.map((client) => {
      return (
        <div key={client.client_id} className={styles.client_wrapper}>
          <div className={styles.client_title_wrapper}>
            <div>{client.fullName}</div>
            <div className={styles.client_tel}>{client.tel}</div>
          </div>
          <svg
            onClick={() => addClientGroup(client, group_id)}
            className={styles.client_add_btn}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
              x="0.498718"
              y="2.60378"
              width="34.7273"
              height="33.0189"
              rx="10"
              fill="#34A95E"
            />
            <path
              d="M16.7169 26.4091V11.4091H19.2623V26.4091H16.7169ZM10.4896 20.1818V17.6364H25.4896V20.1818H10.4896Z"
              fill="white"
            />
          </svg>
        </div>
      );
    });
  };

  // Пошук
  const searchСlients = (clients, inputValue) => {
    setSearch(inputValue);

    const result = [];

    clients.forEach((item) => {
      if (item.fullName.toLowerCase().search(inputValue.toLowerCase()) != -1) {
        result.push(item);
      }
    });
    setSearchСlientsArray(result);
  };

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <div className={styles.header_wrapper}>
        <div className={styles.header_back_btn} onClick={() => navigate(-1)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
        <div className={styles.header_title}>
          Клієнти{' '}
          {search
            ? getClientsNotParticipationGroup(searchСlientsArray).length
            : getClientsNotParticipationGroup(clients).length}
        </div>
      </div>
      {/* -------------- /Header ------------------------ */}
      <div className={styles.content_wrapper}>
        <div className={styles.clients_wrapper}>
          <input
            type="text"
            className={styles.input_search}
            placeholder="Пошук"
            value={search}
            onChange={(e) => searchСlients(clients, e.target.value.trimStart())}
          />
          {clients.length ? (
            renderClients(
              search
                ? getClientsNotParticipationGroup(searchСlientsArray)
                : getClientsNotParticipationGroup(clients),
            )
          ) : loaderPage ? (
            <div>Загрузка...</div>
          ) : (
            <div>Пусто:)</div>
          )}
        </div>
      </div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
